module.exports = __webpack_public_path__ + "img/u_edit.f647bd16.svg";